import React from 'react'

import DatePickerModal from './DatePickerModal'
import FilterLink from '../../../../../components/filter/FilterLink'
import FilterListItem from '../../../../../components/list/FilterListItem'

const DatePicker = ({ label, value, icon, presentation, Link, isSelected, recommendedOptions, ...props }) => {
  const [open, setOpen] = React.useState(false)
  presentation = presentation || 'bar'

  const selectedValue = null
  Link = Link || (presentation === 'bar' ? FilterLink : FilterListItem)

  const cleanDate = () => {
    props.onChange(null)
    setOpen(false)
  }

  return (
    <>
      <Link
        icon={presentation === 'bar' && (icon || 'RiCalendarEventFill')}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
        onClear={cleanDate}
        isSelected={isSelected}
      />

      <DatePickerModal
        open={open}
        onClose={() => setOpen(false)}
        label={label}
        value={value}
        recommendedOptions={recommendedOptions}
        {...props}
      />
    </>
  )
}

export default DatePicker
